
import { RoomLocalisation, RoomType, UnitType } from '../../../../../../../Plugins/FloorPlan/Models/IRoom';
import { I18n } from 'Locales/I18nService';

export type SelectItemOption = { label: string; value?: string };

export interface RoomOptionItem extends SelectItemOption {
    localisation: Array<RoomLocalisation>;
    unitType?: Array<UnitType>;
    ignoredRoomType?: Array<string>;
    wallOrder?: number;
    ignoredTypes?: Array<RoomType>;
}

export enum RoomTypeValue {
    //TODO RoomType when 'Présence d'un revêtement au sol' === 'Oui'

    //TODO RoomType when 'Présence d'un revêtement au sol' === 'Non'
    BETON_FONDATION_DALLE_BRUTE = 'Béton (dalle brute)',
}

export type RoomInfos = {
    roomWallTypes: Array<SelectItemOption>;
    getRoomFloors: (type: RoomType) => Array<SelectItemOption>;
    getRoomTypes: (localisation?: RoomLocalisation, unitType?: UnitType, type?: RoomType) => Array<SelectItemOption>;
    getCurrentFloorWithoutFlooring: (
        localisation: RoomLocalisation,
        roomType: string,
        type: RoomType
    ) => Array<SelectItemOption>;
    getCurrentFloorWithFlooring: (localisation: RoomLocalisation, type: RoomType) => Array<SelectItemOption>;
    getRoomHeatingTypes: (localisation: RoomLocalisation) => Array<SelectItemOption>;
    PasDeChauffage: string;
};

export const useRoomInfosValues = (): RoomInfos => {

    const roomTypes: Array<RoomOptionItem> =
        [
            {
                label: I18n.get('RoomTypeList_ChambreDressing'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement],
            },
            {
                label: I18n.get('RoomTypeList_Bureau'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement],
            },
            {
                label: I18n.get('RoomTypeList_Salon'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement],
            },
            {
                label: I18n.get('RoomTypeList_SalleManger'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement],
            },
            {
                label: I18n.get('RoomTypeList_Cuisine'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.LocalPro],
                wallOrder: 3,
            },
            {
                label: I18n.get('RoomTypeList_WC'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.CoPro, UnitType.LocalPro],
                wallOrder: 2,
            },
            {
                label: I18n.get('RoomTypeList_SalleEau'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement],
                wallOrder: 1,
            },
            {
                label: I18n.get('RoomTypeList_Buanderie'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement],
            },
            {
                label: I18n.get('RoomTypeList_Veranda'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement],
            },
            {
                label: I18n.get('RoomTypeList_HallEntree'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.CoPro, UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_Couloir'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.CoPro, UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_Garage'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.Maison, UnitType.Appartement],
            },
            {
                label: I18n.get('RoomTypeList_TerasseCouvert'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_TerasseNonCouvert'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_Balcon'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.LocalPro, UnitType.CoPro],
                ignoredTypes: [RoomType.Wall],
            },
            {
                label: I18n.get('RoomTypeList_BordPiscinePlat'),
                localisation: [RoomLocalisation.Inside, RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.Appartement],
                ignoredTypes: [RoomType.Wall],
            },
            {
                label: I18n.get('RoomTypeList_Jardin'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.CoPro, UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_LocalProIndividuel'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_PartieCommuneCoPro'),
                localisation: [RoomLocalisation.Inside, RoomLocalisation.Outside],
                unitType: [UnitType.CoPro],
            },
            {
                label: I18n.get('RoomTypeList_LocalProCollectif'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_ChambreHotel'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_Boutique'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_LieuTresFrequente'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_Industrie'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_Evenementiel'),
                localisation: [RoomLocalisation.Inside, RoomLocalisation.Outside],
                unitType: [UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_Ascenseur'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.CoPro, UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_AutresPartiesCommunes'),
                localisation: [RoomLocalisation.Inside],
                unitType: [UnitType.CoPro],
            },
            {
                label: I18n.get('RoomTypeList_Cour'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.Appartement, UnitType.CoPro, UnitType.LocalPro],
            },
            {
                label: I18n.get('RoomTypeList_ToitTerrasseAvecEtanchéite'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.LocalPro, UnitType.CoPro],
            },
        ];

    const getRoomTypes = (localisation?: RoomLocalisation, unitType?: UnitType, type?: RoomType) => {
        const results = roomTypes.filter(
            (x) =>
                x.localisation &&
                localisation &&
                x.localisation.includes(localisation) &&
                x.unitType &&
                unitType &&
                x.unitType.includes(unitType) &&
                type &&
                !x.ignoredTypes?.includes(type)
        );
        if (type === RoomType.Wall) {
            results.sort((a, b) => (a.wallOrder || Infinity) - (b.wallOrder || Infinity));
        }
        return results;
    };

    const getCurrentFloorWithoutFlooring = (localisation: RoomLocalisation, roomType: string, type: RoomType): SelectItemOption[] => {
        if (type === RoomType.Wall) {
            return [
                { label: I18n.get('RoomCurrentFlooringList_PlacoPlatreCiment') },
                { label: I18n.get('RoomCurrentFlooringList_Beton_Wall') },
                { label: I18n.get('RoomCurrentFlooringList_Bois') },
                { label: I18n.get('RoomCurrentFlooringList_Pierre') },
                { label: I18n.get('RoomCurrentFlooringList_Parpaing') },
            ];
        }
        if (type === RoomType.Stairs) {
            return [
                { label: I18n.get('RoomCurrentFlooringList_EscalierEnBois') },
                { label: I18n.get('RoomCurrentFlooringList_EscalierEnBeton') },
                { label: I18n.get('RoomCurrentFlooringList_EscalierEnMetal') },
            ];
        }
        const roomExistingFlooringTypes: Array<RoomOptionItem> = [
            {
                label: I18n.get('RoomCurrentFlooringList_Ciment'),
                localisation: [RoomLocalisation.Inside, RoomLocalisation.Outside],
                ignoredRoomType: [I18n.get('RoomTypeList_Jardin')],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_PlancherBois'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_BétonPeintCire'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_ChapeSeche'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_Terre'),
                localisation: [RoomLocalisation.Outside],
                ignoredRoomType: [
                    I18n.get('RoomTypeList_TerasseCouvert'),
                    I18n.get('RoomTypeList_TerasseNonCouvert'),
                    I18n.get('RoomTypeList_ToitTerrasseAvecEtanchéite'),
                ],
            },
            {
                value: RoomTypeValue.BETON_FONDATION_DALLE_BRUTE,
                label: I18n.get('RoomCurrentFlooringList_Beton'),
                localisation: [RoomLocalisation.Inside, RoomLocalisation.Outside],
                ignoredRoomType: [I18n.get('RoomTypeList_Jardin')],
            },
            {
                label: I18n.get('RoomTypeList_GraviersEnrobes'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.LocalPro, UnitType.CoPro],
                ignoredRoomType: [
                    I18n.get('RoomTypeList_TerasseCouvert'),
                    I18n.get('RoomTypeList_TerasseNonCouvert'),
                ],
            },
            {
                label: I18n.get('RoomTypeList_StructureBoisMetal'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.LocalPro, UnitType.CoPro],
                ignoredRoomType: [I18n.get('RoomTypeList_ToitTerrasseAvecEtanchéite')],
            },
        ];
        return roomExistingFlooringTypes
            .filter((x) => x.localisation.includes(localisation))
            .filter((x) => !x.ignoredRoomType?.includes(roomType));
    };

    const getCurrentFloorWithFlooring = (localisation: RoomLocalisation, type: RoomType): SelectItemOption[] => {
        if (type === RoomType.Wall) {
            return [
                { label: I18n.get('RoomCurrentFlooringList_Carrelage'), },
                { label: I18n.get('RoomCurrentFlooringList_Peinture'), },
                { label: I18n.get('RoomCurrentFlooringList_PapierPeint'), },
                { label: I18n.get('RoomCurrentFlooringList_Crepis'), },
                { label: I18n.get('RoomCurrentFlooringList_Lambris'), },
                { label: I18n.get('RoomCurrentFlooringList_MoquetteMurale'), },
                { label: I18n.get('RoomCurrentFlooringList_VinyleMural'), },
            ];
        }
        if (type === RoomType.Stairs) {
            return [
                { label: I18n.get('RoomCurrentFlooringList_EscalierRecouvertMoquette') },
                { label: I18n.get('RoomCurrentFlooringList_EscalierRecouvertParquet') },
                { label: I18n.get('RoomCurrentFlooringList_EscalierRecouvertPassageEscalier') },
                { label: I18n.get('RoomCurrentFlooringList_EscalierRecouvertCarrelage') }
            ];
        }

        const roomCurrentFloorWithFlooringTypes: Array<RoomOptionItem> = [
            {
                label: I18n.get('RoomCurrentFlooringList_ParquetColle'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_ParquetStratifieNonColle'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_Carrelage'),
                localisation: [RoomLocalisation.Inside, RoomLocalisation.Outside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_Moquette'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_RevetementPlastique'),
                localisation: [RoomLocalisation.Inside, RoomLocalisation.Outside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_TerasseBoisComposite'),
                localisation: [RoomLocalisation.Outside],
            },
            {
                label: I18n.get('RoomCurrentFlooringList_Paves'),
                localisation: [RoomLocalisation.Outside],
                unitType: [UnitType.Maison, UnitType.LocalPro, UnitType.CoPro],
            },
        ];
        return roomCurrentFloorWithFlooringTypes.filter((x) => x.localisation.includes(localisation));
    };

    const PasDeChauffage = I18n.get('RoomHeatingTypeList_PasDeChauffage');

    const getRoomHeatingTypes = (localisation: RoomLocalisation): Array<SelectItemOption> => {
        const roomTypes: Array<RoomOptionItem> = [
            {
                label: I18n.get('RoomHeatingTypeList_BasseTemperatureEau'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomHeatingTypeList_BasseTemperatureAccumulation'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomHeatingTypeList_HauteTemperature'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomHeatingTypeList_ElectriqueRayonnant'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomHeatingTypeList_Reversible'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomHeatingTypeList_SystemeRapporte'),
                localisation: [RoomLocalisation.Inside],
            },
            {
                label: I18n.get('RoomHeatingTypeList_UnknownType'),
                localisation: [RoomLocalisation.Inside],
            },
        ];
        return roomTypes.filter((x) => localisation && x.localisation.includes(localisation));
    };

    const roomWallTypes: Array<SelectItemOption> = [
        { label: I18n.get('RoomWallTypeList_Mur'), },
        { label: I18n.get('RoomWallTypeList_Credence'), },
        { label: I18n.get('RoomWallTypeList_TablierBaignoire'), },
    ];

    return {
        roomWallTypes,
        getRoomFloors,
        getRoomTypes,
        getCurrentFloorWithoutFlooring,
        getCurrentFloorWithFlooring,
        getRoomHeatingTypes,
        PasDeChauffage,
    };
};

const getRoomFloors = (mapElementType: RoomType): Array<SelectItemOption> => {
    switch (mapElementType) {
        case RoomType.Sol:
        case RoomType.Wall:
            return [
                { label: I18n.get('RoomFloorList_RDC'), },
                { label: I18n.get('RoomFloorList_Etage1a3') },
                { label: I18n.get('RoomFloorList_4etPlus') }
            ];
        case RoomType.Stairs:
            return [
                { label: I18n.get('StairsFloorList_RDC'), },
                { label: I18n.get('StairsFloorList_Etage1a2') },
                { label: I18n.get('StairsFloorList_Etage2a3') },
                { label: I18n.get('StairsFloorList_Etage3a4') },
                { label: I18n.get('StairsFloorList_Etage4etPlus') },
            ];
        default:
            return []
    }
}